import { OPACITY } from '@optimus-web/local-tokens';

import { TextOpacityVariants } from './types';

const textOpacityVariants: TextOpacityVariants = {
    primary: OPACITY.primary,
    secondary: OPACITY.secondary,
    disabled: OPACITY.disabled,
};

export default textOpacityVariants;
